(() => {
  const dialog = document.getElementById('JbStorePicker');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'jb-store-picker-seen-v1';
  const remember = () => { try { sessionStorage.setItem(key, '1'); } catch {} };
  const close = () => { remember(); dialog.close(); };
  const open = () => {
    if (dialog.open) return;
    dialog.showModal();
    document.body.classList.add('jb-picker-open');
  };
  dialog.addEventListener('close', () => { remember(); document.body.classList.remove('jb-picker-open'); });
  dialog.addEventListener('click', event => {
    if (event.target === dialog) {
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
    }
    if (event.target.closest('[data-jb-picker-close]')) close();
    const choice = event.target.closest('[data-jb-choice]');
    if (!choice) return;
    const currentStorePage = new URL(choice.href).pathname === location.pathname;
    const homeDefault = dialog.dataset.autoOpen === 'true' && choice.dataset.jbChoice === 'books';
    if (currentStorePage || homeDefault) event.preventDefault();
    close();
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-jb-store-trigger]');
    if (trigger) {
      event.preventDefault();
      const drawer = trigger.closest('header-drawer');
      if (drawer && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event, drawer.querySelector('summary'));
      open();
    }
  });
  document.querySelectorAll('.jb-nav-dropdown').forEach(dropdown => {
    dropdown.addEventListener('toggle', () => {
      if (dropdown.open) document.querySelectorAll('.jb-nav-dropdown[open]').forEach(other => { if (other !== dropdown) other.open = false; });
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.jb-nav-dropdown[open]').forEach(dropdown => { if (!dropdown.contains(event.target)) dropdown.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.jb-nav-dropdown[open]').forEach(dropdown => { dropdown.open = false; dropdown.querySelector('summary')?.focus(); });
  });
  let seen = false;
  try { seen = sessionStorage.getItem(key) === '1'; } catch { seen = true; }
  if (dialog.dataset.autoOpen === 'true' && !seen) open();
})();
